import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getLocalProductLevel, getUserData, setLocalProductLevel } from "../utils/localStorage";
import { getProductLevel } from "../services/userMasterUser";
import { errorMessage } from "../utils/alertMessage";
import { getUserLead, getUserLeadSummary } from "../services/leads";
import { Link } from "react-router-dom";

const DashboardTeleCaller = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const [leadData, setLeadData] = useState("")

  const [startDate, setStartDate] = useState(new Date(localStorage.getItem("startDateFilter")));
  const [endDate, setEndDate] = useState(new Date(localStorage.getItem("endDateFilter")));


  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const boxFieldData = {
    leadTypeIn: [],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    sortBy: "",
    sortOrder: "desc",
    userIdIn: [userProfileData.id],
    statusIn: [
      "ASSIGN",
      "in process",
      "call not pick up",
      "not interested",
      "not doable",
      "hold for follow up after sometime",
      "prelogin",
      "login",
      "sanction",
      "disbursement",
      "decline",
      "hold by customer",
    ],

  };
  const fetchBoxFieldData = (data) => {

    getUserLeadSummary(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          const totalCount = rawData?.reduce(
            (sum, item) => sum + (item?.count || 0),
            0
          );
          const totalAmount = rawData?.reduce(
            (sum, item) => sum + (item?.totalAmount || 0),
            0
          );

          setLeadData(totalCount)

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  useEffect(() => {
    fetchBoxFieldData(boxFieldData)
  }, [])

  // const statuses = ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER", "DONE"];

  // const leadStatusMap2 = Object.groupBy(leadData, item => item.status);

  // const result = statuses.map(status => {
  //   const items = leadStatusMap2[status] || [];

  //   return {
  //     status,
  //     count: items.length,
  //     amount: items.reduce((sum, item) => sum + (item.lead?.amount || 0), 0)
  //   };
  // });





  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Tele Caller Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                    </div>

                    <div class="sec-hdr">
                      <div class="sec-ico">
                        📥
                      </div>
                      <div>
                        <div class="sec-title">Lead Box</div>
                      </div>
                    </div>

                    <div class="kpi-grid" id="kpi-grid">
                      <div class="kpi-card">
                        <div class="kpi-accent" style={{ background: "#1a6b32" }}></div>
                        <div class="kpi-icon-wrap" style={{ background: "#e8f5ed" }}><i class="pi pi-users" style={{ color: "#1a6b32", fontSize: '20px' }}></i></div>
                        <div class="kpi-label">Total Leads</div>
                        <div class="kpi-val" id="kpi-total">{leadData}</div>
                        <div class="kpi-sub">All time</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardTeleCaller;
